import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, from, of, throwError } from 'rxjs';
import { AppAttendance, AppAttendanceSummary } from '../models/appAttendace.model';

import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LivesSessionHelper } from '../helper/livesSessionHelper';
import { SessionHelper } from '../helper/sessionHelper';

//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable({ providedIn: 'root' })
export class AppAttendanceService extends HttpClientBaseService implements IServiceBase<AppAttendance> {



  constructor(
    _http: HttpClient,
    private _session: SessionHelper,
    private _livesSession: LivesSessionHelper
  ) {
    super(_http, '/workCenters/', '', false);


  }

  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppAttendance>> {
    throw new Error('Method not implemented.');
  }

  getAllModels(): any {
    throw new Error('Method not implemented.');
  }

  public getModel(id: any): any {
    throw new Error('Method not implemented.');
  }

  getAllModelsAttendance(companyId?: string, dateFrom?: string, dateTo?: string, imputationCode?: string, company?: string, companyCode?: number, environment?: string): Observable<any> {
    const environmentId = this._livesSession.EnvironmentId;
    const hrUserId = this._livesSession.AspNetUserId;
    if (!environmentId) {
      return throwError(new Error("No environment ID found in session storage"));
    }
    if (!hrUserId) {
      return throwError(new Error("No HR User ID found in session storage"));
    }

    const userRoles: string[] = this._session.User.Roles || [];
    const userId = this._livesSession.AspNetUserId;
    
    // Construir los parámetros de roles
    const rolesParams = userRoles.map(role => `aspNetUserRole=${encodeURIComponent(role)}`).join('&');

    let url = `${AppConfig.settings.apiServerPE.apiUrl}attendance/records/individual?environment=${environmentId}&source=WEB&aspNetUserId=${userId}&${rolesParams}`;

    if (companyId && !imputationCode) {
      url += `&company=${companyId}`;
    }
    if (dateFrom) {
      url += `&dateFrom=${dateFrom}`;
    }
    if (dateTo) {
      url += `&dateTo=${dateTo}`;
    }
    if (dateFrom || dateTo) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      url += `&timeZone=${encodeURIComponent(timeZone)}`;
    }
    if (imputationCode && company && companyCode && environment) {
      url += `&company=${company}&companyCode=${companyCode}&imputationCode=${imputationCode}`;
    }

    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.get<any>(url, { headers: headers });
  }


  getAllModelsAttendanceGrouped(companyId?: string, dateFrom?: string, dateTo?: string, imputationCode?: string, company?: string, companyCode?: number, environment?: string): Observable<any> {
    const environmentId = this._livesSession.EnvironmentId;
    const hrUserId = this._livesSession.AspNetUserId;

    if (!environmentId) {
      return throwError(new Error("No environment ID found in session storage"));
    }
    if (!hrUserId) {
      return throwError(new Error("No HR User ID found in session storage"));
    }

    const userRoles: string[] = this._session.User.Roles || [];
    const userId = this._livesSession.AspNetUserId;

    // Construir los parámetros de roles
    const rolesParams = userRoles.map(role => `aspNetUserRole=${encodeURIComponent(role)}`).join('&');

    let url = `${AppConfig.settings.apiServerPE.apiUrl}attendance/records/summary?environment=${environmentId}&aspNetUserId=${userId}&${rolesParams}`;

    if (companyId && !imputationCode) {
      url += `&company=${companyId}`;
    }
    if (dateFrom) {
      url += `&dateFrom=${dateFrom}`;
    }
    if (dateTo) {
      url += `&dateTo=${dateTo}`;
    }
    if (dateFrom || dateTo) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      url += `&timeZone=${encodeURIComponent(timeZone)}`;
    }
    if (imputationCode && company && companyCode && environment) {
      url += `&company=${company}&companyCode=${companyCode}&imputationCode=${imputationCode}`;
    }

    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.get<any>(url, { headers: headers });
  }

  public createModel(data: Partial<AppAttendance>): Observable<AppAttendance> {
    const environmentId = this._livesSession.EnvironmentId;
    const hrUserId = this._livesSession.AspNetUserId;
    if (!environmentId) {
      return throwError(new Error("No environment ID found in session storage"));
    }
    if (!hrUserId) {
      return throwError(new Error("No HR USer ID found in session storage"));
    }

    const url = `${AppConfig.settings.apiServerPE.apiUrl}attendance/record`;

    const body = {
      "type": data.type,
      "environment": environmentId,
      "company": data.company,
      "source": data.source,
      "user": data.user,
      "workCenter": data.workCenter,
      "coordinates": null,
      "notes": data.notes,
      "localAttendanceAt": data.localAttendanceAt,
      "timeZone": data.timeZone,
      "createdBy": hrUserId,
      "modifiedBy": hrUserId
    }
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.post<any>(url, body, { headers: headers });
  }

  public updateModel({ id, data }): Observable<AppAttendance> {

    const hrUserId = this._livesSession.AspNetUserId;
    if (!hrUserId) {
      return throwError(new Error("No HR USer ID found in session storage"));
    }

    const url = `${AppConfig.settings.apiServerPE.apiUrl}attendance/record?attendanceRecordId=${id}`;

    const body = {
      "notes": data.notes,
      "modifiedBy": hrUserId
    }

    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.patch<any>(url, body, { headers: headers });
  }

  public toggleValid({ id, data }): Observable<AppAttendance> {

    const hrUserId = this._livesSession.AspNetUserId;
    if (!hrUserId) {
      return throwError(new Error("No HR USer ID found in session storage"));
    }

    const url = `${AppConfig.settings.apiServerPE.apiUrl}attendance/record?attendanceRecordId=${id}`;

    const body = {
      "valid": !data.valid,
      "notes": data.notes,
      "modifiedBy": hrUserId
    }

    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.patch<any>(url, body, { headers: headers });
  }

  public toggleEnabled({ id, data }): Observable<AppAttendance> {

    const hrUserId = this._livesSession.AspNetUserId;
    if (!hrUserId) {
      return throwError(new Error("No HR USer ID found in session storage"));
    }

    const url = `${AppConfig.settings.apiServerPE.apiUrl}attendance/record?attendanceRecordId=${id}`;

    const body = {
      "enabled": !data.enabled,
      "modifiedBy": hrUserId
    }


    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.patch<any>(url, body, { headers: headers });
  }
}
